<template>
    <div class="mobile:block laptop:flex items-center justify-between">
        <div v-if=" quoteDetail.partner_info != null && quoteDetail.partner_info.is_tradecall_fee_applicable == 1" class="mobile:mb-4 laptop:mb-0">
            <h2 class="text-[14px] laptop:text-[16px]">
                <span class="text-[#FE5000]">Important: </span> <br class="block laptop:hidden">
                <span class="font-bold text-[#000000]">
                    ${{$helper.formatAmount(quoteDetail.partner_info.tradecall_fee)}}
                </span>
                <span class="text-[#666666]"> TradeCall Fee to be collected from {{ quoteDetail.consumer.full_name
                }}</span>
            </h2>
        </div>
        <div class="mobile:flex mobile:justify-center laptop:ml-auto">
            <button
                class="group/submit flex items-center justify-center gap-3 w-[150px] h-[40px] rounded-full mobile:py-1 px-2 tablet:py-1.5 border-1 border-[#092E87] mobile:bg-[#092E87] laptop:bg-[#fff] text-[#092E87] laptop:hover:bg-[#092E87]"
                @click="updateSummary">
                <span
                    class="text-[14px] mobile:text-[#fff] laptop:text-[#092E87] group-hover/submit:text-[#fff]">Submit Quote</span>
                <img src="../../assets/images/submit-quote-button-icon.png"
                    class="h-[26px] w-[26px] mobile:hidden laptop:block group-hover/submit:hidden"
                    alt="">
                <img src="../../assets/images/submit-quote-button-hover-icon.png"
                    class="h-[26px] w-[26px] mobile:block laptop:hidden group-hover/submit:block">
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import { param } from "jquery";
const toast = useToast();

export default {

    props: ['no_of_units', 'validateBeforeSubmit', 'saveBeforeSubmit'],
    components: {
    },

    data() {
        return {

        };
    },
    computed: {
        ...mapGetters([
            "quoteDetail",
        ]),
        
        isPartnerQuote() {
            return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
        }
    },


    mounted() {

    },

    methods: {
        ...mapActions([
            "postQuoteSummary",
        ]),

        updateSummary() {
            if (typeof this.validateBeforeSubmit === 'function' && !this.validateBeforeSubmit()) {
                return;
            }

            this.$dialog.show({
                title: "Submit Quote",
                text: "Are you sure you want to submit this quote?",
                // we are passing callback method for our confirm button
                onConfirm: async () => {
                    if (typeof this.saveBeforeSubmit === 'function') {
                        const isSaved = await this.saveBeforeSubmit();
                        if (!isSaved) {
                            return;
                        }
                    }

                    if (this.isPartnerQuote) {
                        this.postQuoteSummary({
                            url: "/manual-quote/partner/update",
                            params: {
                                manual_quote_id: this.quoteDetail.id,
                                number_of_units: this.no_of_units
                            }
                        });
                    } else {
                        this.postQuoteSummary({
                            url: "/manual-quote/submit-quote",
                            params: {
                                manual_quote_id: this.quoteDetail.id,
                                number_of_units: this.no_of_units
                            }
                        });
                    }
                    
                },
            });
        },
    },
};
</script>